<template>
    <div id="step3">
        <a-result v-if="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" status="warning" title="Please select item(s) first."></a-result>
        <a-row v-else>
            <p style="font-size: 13px;font-weight: 800;" class="sbxs mt4"><a-icon type="caret-down" />Delivery Address</p>
            <a-row class="step5_Order">
                <a-form :form="form">
                    <a-row>
                        <a-col :span="12">
                            <a-form-item label="Consignee" v-bind="formItemLayout">
                                <a-input-search
                                        size="small"
                                        autocomplete="off"
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        style="width: 100%"
                                        @search="consigneeSearch"
                                        v-decorator="['consignee',
                                    {
                                        initialValue: onsigneecValue.consignee,
                                        rules: [{ required: true, message: $t('publicLang.Required')
                                    }]}
                             ]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Contact" v-bind="formItemLayout">
                                <a-input
                                        autocomplete="off"
                                        size="small"
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        v-decorator="['contact',{ initialValue: onsigneecValue.contact}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Phone" v-bind="formItemLayout">
                                <a-input
                                        size="small"
                                        autocomplete="off"
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        v-decorator="['phone',
                                 { initialValue: onsigneecValue.tel1,rules: [{ required: true,
                                                                                validator: checkPhone,
                                  }]}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Email" v-bind="formItemLayout">
                                <a-input
                                        size="small"
                                        autocomplete="off"
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        v-decorator="['email',{ initialValue: onsigneecValue.email}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Address 1" v-bind="formItemLayout">
                                <a-input
                                        size="small"
                                        autocomplete="off"
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        v-decorator="['address1',{ initialValue: onsigneecValue.address1,
                                                                    rules: [
                                                                      {
                                                                        validator: checkInputEn,
                                                                      },
                                                                    ],
                                        }]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Address 2" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                         v-decorator="['address2',{initialValue: onsigneecValue.address2,
                                                                    rules: [
                                                                      {
                                                                        // validator: checkInputEn,
                                                                      },
                                                                    ],
                                         }]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="中文地址" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['address3',{initialValue: onsigneecValue.address3,
                                    rules: [
                                          {
                                            validator: checkInputCn,
                                          },
                                    ]
                                }]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="District" v-bind="formItemLayout">
                                <a-select
                                        style="width: 100%;" allowClear  size="small" :placeholder="$t('publicLang.PleaseSelect')"
                                        v-decorator="['address4',{initialValue: onsigneecValue.address4}]">
                                    <a-select-option v-for="item in stepSelectData.tmsDistrict" :value="item.code">{{item.codeDesc}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="City" v-bind="formItemLayout">
                                <a-input
                                        size="small"
                                        autocomplete="off"
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        v-decorator="['city',{initialValue: onsigneecValue.city}]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="State" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['state',{initialValue: onsigneecValue.state}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Country" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['country',{initialValue: onsigneecValue.country}]"/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Zip" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['zip',{initialValue: onsigneecValue.zip}]"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-row>
        </a-row>


        <div style="height: 45px;"></div>

        <div
             :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1,}">
            <a-button @click='goTypeClick("Back")' class="fl" type="primary" size="small"><img src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>
            <a-button :disabled="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" @click='goTypeClick("Next")' class="fr" type="primary" size="small"><img src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Next</a-button>
            <div style="text-align: center">
                <a-button :disabled="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" @click="saveStep3" type="primary" size="small"><img src="../../../../assets/img/Liqutor-save.png" width="13" height="12" class="mr4">Save and Exit</a-button>

                <a-popconfirm
                        title="Are you sure reset?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="resetStep3"
                >
                    <a-button :disabled="initCloseValue.invTempDetailList == null || initCloseValue.invTempDetailList.length == 0" style='margin-left: 40px;' type="danger" size="small"><img src="../../../../assets/img/Liqutor-refresh.png" width="13" height="12" class="mr4">Reset</a-button>
                </a-popconfirm>


            </div>
        </div>
        <!--搜索-->
        <a-modal
            title="Consignee"
            :visible="consigneeVis"
            width="80%"
            :footer="null"
            @cancel="() => (consigneeVis = !consigneeVis)"
        >
            <a-row style="height: 450px;">
                <vxe-table
                    stripe
                    highlight-hover-row
                    border
                    resizable
                    show-overflow
                    :data.sync="onsigneecTable"
                    size="mini"
                    height="auto"
                    @cell-click="cellClickEvent"
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;"> {{ $t('pubGicSet.NoRecordfound') }} </span>
                    </template>
                    <vxe-table-column field="consignee" title="Consignee" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="contact" title="Contact" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="tel1" title="Phone" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="postalCode" title="Email" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="address1" title="Address1" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="address2" title="Address2" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="address3" title="Address3" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="address4" title="Address4" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="city" title="City" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="state" title="State" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="country" title="Country" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                    <vxe-table-column field="zip" title="Zip" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                </vxe-table>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import { mapState } from "vuex"
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        props:{
            initCloseValue:{
                type: Object,
                default: function() {
                    return {};
                }
            },
            stepSelectData: {
                type: Object,
                default: function() {
                    return {};
                }
            },
        },
        data(){
            return{
                form: this.$form.createForm(this),
                onsigneecTable: [],
                onsigneecValue:{},
                consigneeVis: false,
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 6 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                address1Check:false,
                test: false
            }
        },
	computed: {
             ...mapState(["systemParam"]),
        },
        watch:{
        initCloseValue(){
                this.clearFromInitValue()
                     this.onsigneecValue = {
                         zip:this.initCloseValue.zip,
                         country: this.initCloseValue.country,
                         state: this.initCloseValue.state,
                         city: this.initCloseValue.city,
                         address1: this.initCloseValue.address1,
                         address2: this.initCloseValue.address2,
                         address3: this.initCloseValue.address3,
                         address4: this.initCloseValue.address4,
                         email: this.initCloseValue.email,
                         tel1: this.initCloseValue.phone,
                         contact: this.initCloseValue.contact,
                         consignee: this.initCloseValue.consignee,
                     }
            }   
        },
        created() {
                this.clearFromInitValue()
                this.onsigneecValue = {
                    zip:this.initCloseValue.zip,
                    country: this.initCloseValue.country,
                    state: this.initCloseValue.state,
                    city: this.initCloseValue.city,
                    address1: this.initCloseValue.address1,
                    address2: this.initCloseValue.address2,
                    address3: this.initCloseValue.address3,
                    address4: this.initCloseValue.address4,
                    email: this.initCloseValue.email,
                    tel1: this.initCloseValue.phone,
                    contact: this.initCloseValue.contact,
                    consignee: this.initCloseValue.consignee,
                 }
        },
        methods:{
//            consigneeSearch
            consigneeSearch(){
                this.consigneeVis = true
                let params = {
                    "btperpkg": this.form.getFieldValue('btperpkg'),
                    "consignee": this.form.getFieldValue('consignee'),
                    "itemRemark": this.form.getFieldValue('itemRemark'),
                    "itemSize": this.form.getFieldValue('itemSize'),
                    "region": this.form.getFieldValue('region'),
                    "sku": this.form.getFieldValue('sku'),
                    "wineName": this.form.getFieldValue('wineName'),
                    "year": this.form.getFieldValue('year')
                }
                for(let i in params){
                    if (params[i] == '') {
                        delete params[i]
                    }
                }
                ajax.post(api.INVWINECONSIGNEE,params).then(res=>{
                    this.onsigneecTable = res.data
                })
            },
//            next 跳转
            goTypeClick(type){
                if(this.initCloseValue == null || this.initCloseValue == undefined || this.initCloseValue.invTempDetailList == null || this.initCloseValue.invTempDetailList.length == 0){
                   if(type != 'Back'){
                        this.$emit('goType',type)
                   }
                   return
                }
                if(type != 'Back'){ // leaveSetp3 切换其他页面，离开Setp3 保存Setp3
                    this.form.validateFields((err, values)=>{
                         if(!err){
                             let params = {
                                 "address1": values.address1,
                                 "address2": values.address2,
                                 "address3": values.address3,
                                 "address4": values.address4,
                                 "tel": values.phone,
                                 "city": values.city,
                                 "consignee": values.consignee,
                                 "contact": values.contact,
                                 "country": values.country,
                                 "currentStep": '3',
                                 "email": values.email,
                                 "state": values.state,
                                 "zip":  values.zip
                             }
                             ajax.post(api.INVWINEADDTEMPORDER, params).then(res=>{
                                 if(res.code == 200){
                                     this.$emit('setInitCloseValue',this.initCloseValue)
                                     this.$emit('goType',type)
                                 }else{
                                     this.$message.warning(res.msg);
                                 }
                             })
                         }
                    })
                }else{
                    this.$emit('goType',type)
                }
            },

//            save
            saveStep3(){
                this.form.validateFields((err, values)=>{
                    if(!err){
                        let params = {
                            "address1": values.address1,
                            "address2": values.address2,
                            "address3": values.address3,
                            "address4": values.address4,
                            "tel": values.phone,
                            "city": values.city,
                            "consignee": values.consignee,
                            "contact": values.contact,
                            "country": values.country,
                            "currentStep": '3',
                            "email": values.email,
                            "state": values.state,
                            "zip":  values.zip
                        }
                        ajax.post(api.INVWINEADDTEMPORDER, params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.$emit('emitValue',{type: 'step3', data: values})
                                this.$emit('goClose','close')
                            }else{
                                this.$message.warning(res.msg);
                            }
                        })
                    }
                })
            },
//            清除
            resetStep3(){
                let params = {
                    currentStep: '3',
                }
                ajax.post(api.INVWINEADDTEMPORDER,params).then(res=>{
                    if(res.code == 200){
                        this.form.resetFields();
                        this.onsigneecValue = {}
                    }else{
                        this.$message.warning(res.msg);
                    }
                })
            },
//            consignee选中当前value
            cellClickEvent({ row }){
                this.onsigneecValue= row
                this.form.setFieldsValue({'consignee':  this.onsigneecValue.consignee, 'phone':  this.onsigneecValue.tel1, 'address1':  this.onsigneecValue.address1,})
                this.consigneeVis = false
            },
            clearFromInitValue(){
                this.onsigneecValue = {}
                this.form.resetFields()
            },
            checkInputEn(rule, value, callback){//校验不能输入中文
                let pattern = new RegExp(/^[^\u4e00-\u9fa5]{0,}$/)
                if(!pattern.test(value)){
                    callback(this.$t('wine.inputEnglish'));
                }else{
                    callback();
                }
            },
            checkInputCn(rule, value, callback){//校验不能输入英文
                let addr1 = this.form.getFieldValue('address1')
                // let addr2 = this.form.getFieldValue('address2')
                // let pattern = new RegExp(/^[^a-zA-Z]{0,}$/)
                // if((addr1 == null || addr1.length == 0) && (addr2 == null || addr2.length == 0) && (value == null || value.length == 0)){
                if((addr1 == null || addr1.length == 0) && (value == null || value.length == 0)){
                    callback(this.$t('wine.mustInputChinese'));
                }
                // else if(!pattern.test(value)){
                //     callback(this.$t('wine.inputChinese'));
                // }
                else{
                    callback();
                }
            },
            checkPhone(rule, value, callback){//校验长度
                 let so_inv_phone_max = this.systemParam.so_inv_phone_max;
                let sysPhoneLength = so_inv_phone_max == undefined || so_inv_phone_max == null || so_inv_phone_max == 0  ? 20 : so_inv_phone_max;

                if(value == null || value.length == 0){
                    callback(this.$t('publicLang.Required'));
                }else if(value.length > sysPhoneLength){
                    callback(this.$t('wine.maxCharacters', {"0":sysPhoneLength}));
                }else{
                    callback();
                }
            },
        }
    }
</script>
<style lang="less">
    #step3{
        padding:6px 15px 0 15px;
        .step5_Order{
            border: 1px solid #929292;
            background: #fafafa;
            padding: 8px;
        }
    }
</style>